import { useEffect, useState, useCallback, createContext, useContext } from "react";
import { api } from "@/lib/api";

const FeaturesContext = createContext(null);

export function FeaturesProvider({ children }) {
  const [features, setFeatures] = useState([]);
  const [plan, setPlan] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [gate, setGate] = useState({ open: false, requiredFeature: null });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/user/features");
      setFeatures(data.features || []);
      setPlan(data.plan || null);
      setRole(data.role || null);
    } catch {
      setFeatures([]);
      setPlan(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("vb_token")) refresh();
    else setLoading(false);
  }, [refresh]);

  const has = useCallback((f) => role === "admin" || features.includes(f), [features, role]);

  const requireFeature = useCallback((f) => {
    if (has(f)) return true;
    setGate({ open: true, requiredFeature: f });
    return false;
  }, [has]);

  const closeGate = useCallback(() => setGate({ open: false, requiredFeature: null }), []);

  return (
    <FeaturesContext.Provider value={{ features, plan, role, loading, has, requireFeature, gate, closeGate, refresh }}>
      {children}
    </FeaturesContext.Provider>
  );
}

export function useFeatures() {
  const ctx = useContext(FeaturesContext);
  if (!ctx) throw new Error("useFeatures must be used inside FeaturesProvider");
  return ctx;
}
